import script from "./AddPrivateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPrivateModal.vue?vue&type=script&setup=true&lang=js"

import "./AddPrivateModal.vue?vue&type=style&index=0&id=32b205ca&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32b205ca"]])

export default __exports__